import { combineReducers } from '@reduxjs/toolkit';
import uiReducer from './ui';
import authReducer from './auth';
import settingsReducer from './user-settings';
import appSettingsReducer from './settings';
import talentReducer from './talent';
import talentSearchReducer from './talentSearch';
import shiftReducer from './shifts';
import companyReducer from './company';
import approvedCompaniesReducer from './approvedCompanies';
import otherCompaniesReducer from './otherCompanies';
import skillReducer from './skills';
import certificateReducer from './certificates';
import invoicesReducer from './invoices';
import notificationsReducer from './notifications';
import mapReducer from './map';
import contractorMapReducer from './contractorMap';
import emailMarketingReducer from './emailMarketing';
import reportsReducer from './reports';
import clientInvoiceReportsReducer from './clientInvoiceReports';
import filledUnfilledReportsReducer from './filledUnfilledReports';
import userSignupsReportsReducer from './userSignupsReports';
import shiftApplicationsReportsReducer from './shiftApplicationsReports';
import weeklyInvoiceVerificationReducer from './weeklyInvoiceVerification';
import weeklyUnitNumbersReducer from './weeklyUnitNumbers';
import commandCentreReducer from './commandCentre';
import instantPayReportReducer from './instantPayReport';
import paidContractorInvoiceReportReducer from './paidContractorInvoiceReport';
import contractorWithdrawalsReportReducer from './contractorWithdrawalsReport';
import walletBalanceAgingReportReducer from './walletBalanceAgingReport';
import calendarShiftsReducer from './calendarShifts';
import manualTimeRequestReducer from './manualTimeRequest';
import disputesReducer from './disputes';
import timeTrackerReducer from './timeTracker';
import recurrenceRulesReducer from './recurrenceRules';
import platformSettingsReducer from './platformSettings';

export default combineReducers({
    ui: uiReducer,
    auth: authReducer,
    settings: settingsReducer,
    appSettings: appSettingsReducer,
    talent: talentReducer,
    talentSearch: talentSearchReducer,
    shifts: shiftReducer,
    companies: companyReducer,
    approvedCompanies: approvedCompaniesReducer,
    otherCompanies: otherCompaniesReducer,
    skills: skillReducer,
    certificates: certificateReducer,
    invoices: invoicesReducer,
    notifications: notificationsReducer,
    map: mapReducer,
    contractorMap: contractorMapReducer,
    emailMarketing: emailMarketingReducer,
    reports: reportsReducer,
    clientInvoiceReports: clientInvoiceReportsReducer,
    filledUnfilledReports: filledUnfilledReportsReducer,
    userSignupsReports: userSignupsReportsReducer,
    shiftApplicationsReports: shiftApplicationsReportsReducer,
    weeklyInvoiceVerification: weeklyInvoiceVerificationReducer,
    weeklyUnitNumbers: weeklyUnitNumbersReducer,
    commandCentre: commandCentreReducer,
    instantPayReport: instantPayReportReducer,
    paidContractorInvoiceReport: paidContractorInvoiceReportReducer,
    contractorWithdrawalsReport: contractorWithdrawalsReportReducer,
    walletBalanceAgingReport: walletBalanceAgingReportReducer,
    calendarShifts: calendarShiftsReducer,
    manualTimeRequest: manualTimeRequestReducer,
    disputes: disputesReducer,
    timeTracker: timeTrackerReducer,
    recurrenceRules: recurrenceRulesReducer,
    platformSettings: platformSettingsReducer,
});
